import { useMutation } from '@tanstack/react-query'
import { PartyPopper } from 'lucide-react'
import { useEffect, useState } from 'react'

import { getCampaigns } from '@/api/campaigns/get-campaigns'
import { Card, CardContent } from '@/components/ui/card'
import { env } from '@/env'
import { useHeadManager } from '@/lib/headManagerProvider'

import { AwardedCampaignModal } from '../components/awardedCampaignModal'
import type { GetCampaigns } from '../types'

export function AwardedCampaigns() {
  const { setTitle } = useHeadManager()
  const [awardedOpen, setAwardedOpen] = useState(false)
  const [selectedAwarded, setSelectedAwarded] = useState<GetCampaigns | null>(
    null,
  )

  const getAllCampaigns = useMutation({
    mutationFn: getCampaigns,
  })

  useEffect(() => {
    setTitle('Campanhas Premiadas')
    getAllCampaigns.mutate()
  }, [setTitle])

  const openAwarded = (campaign: GetCampaigns) => {
    setSelectedAwarded(campaign)
    setAwardedOpen(true)
  }

  let campanhasPremiadas: GetCampaigns[] = []

  if (getAllCampaigns.data) {
    campanhasPremiadas = getAllCampaigns.data.filter(
      (campanha) => campanha.campanha.sorteado === true,
    )
  }

  return (
    <div className="space-y-6 p-6">
      <h1 className="text-2xl font-bold">Campanhas Premiadas</h1>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        {campanhasPremiadas?.map((campanha) => (
          <Card
            key={`premiada-${campanha.campanha.id}`}
            className="hover:ring-primary cursor-pointer overflow-hidden rounded-2xl shadow-md transition hover:ring-2"
            onClick={() => openAwarded(campanha)}
          >
            <div className="relative">
              <img
                src={`${env.VITE_API_URL}${campanha.campanha.imagem}`}
                alt={campanha.campanha.titulo}
                className="h-32 w-full object-cover brightness-75"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <PartyPopper className="h-[50%] w-[50%] text-white opacity-90 drop-shadow-lg" />
              </div>
              <div className="absolute bottom-1 left-2 text-xs text-white">
                Clique para ver o ganhador
              </div>
            </div>
            <CardContent className="space-y-1 p-3">
              <h3 className="text-base font-semibold">
                {campanha.campanha.titulo}
              </h3>
              <p className="text-muted-foreground text-sm">
                {campanha.campanha.descricao}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>

      <AwardedCampaignModal
        open={awardedOpen}
        onOpenChange={setAwardedOpen}
        campaign={selectedAwarded}
      />
    </div>
  )
}
